import { Switch, Route } from "react-router-dom";

import ExamInvitationComplete from "../../components/common/complete/examInvitationComplete/ExamInvitationComplete";
import NotFound from "../../components/common/error/notFound/NotFound";
import Editor from "../../components/user/editor/Editor.connect";
import EditorReadme from "../../components/user/editorReadme/EditorReadme.connect";
import ExamEntrance from "../../components/user/examEntrance/ExamEntrance.connect";
import ExamEntranceId from "../../components/user/examEntrance/ExamEntranceId.connect";

/**
 * Route setting
 */
export default function UserRoute() {
  return (
    <Switch>
      <Route
        path="/invitation/sent"
        exact={true}
        component={ExamInvitationComplete}
      />
      <Route
        path="/:orgname/share/:token"
        exact={true}
        component={ExamEntrance}
      />
      <Route
        path="/:orgname/idshare/:token"
        exact={true}
        component={ExamEntranceId}
      />
      <Route
        path="/:orgname/exams/:token/challenges/:challengeId/readme"
        exact={true}
        render={({ match }) => (
          <EditorReadme challengeId={parseInt(match.params.challengeId, 10)} />
        )}
      />
      <Route path="/:orgname/exams/:token" component={Editor} />
      <Route path="/tutorial" component={Editor} />
      <Route render={() => <NotFound hasBackButton={false} />} />
    </Switch>
  );
}
